'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function toCurrentProtocol(url) {
    return (url || '').replace(/^(https*\:\/\/)/gi, location.protocol + '//');
}

exports.toCurrentProtocol = toCurrentProtocol;
